import API from "../../services/API"
import getUrl from "./getUrl"

export default (bucketName, locale) => {
  const url = getUrl(bucketName, locale)

  return API.get(url, {unAuth: true}).then((res) => res.data).catch(() => {
    console.warn(`[Content]: Failed to load ${bucketName} for ${locale}`)
  })
}
